<template>
    <div>
        <body style='text-align:center; padding-top:100px;'>
            <img src='../public/404.jpg'>
        </body>
    </div>
</template>
<script>
export default {
    created () {
        this.$router.push('/error')
    }
}
</script>